import React from 'react';

const useEffect = (func: any, dependencies: any, usedDependencies?: any) => {
  React.useEffect(func, usedDependencies ? usedDependencies : dependencies); // eslint-disable-line
};

export {
  useEffect,
};